import React from 'react'

const AdminCustomersSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-7xl space-y-8 px-4 py-8">
        <div className="space-y-3">
          <div className="h-8 w-64 animate-pulse rounded bg-gray-200" />
          <div className="h-4 w-96 animate-pulse rounded bg-gray-200" />
        </div>

        <div className="grid gap-4 md:grid-cols-3">
          {Array.from({ length: 3 }).map((_, index) => (
            <div
              key={`customers-skeleton-card-${index}`}
              className="h-32 animate-pulse rounded-xl border border-gray-100 bg-white shadow-sm"
            />
          ))}
        </div>

        <div className="rounded-xl border border-gray-100 bg-white p-6 shadow-sm">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div className="h-10 w-full animate-pulse rounded bg-gray-100 md:w-80" />
            <div className="h-10 w-full animate-pulse rounded bg-gray-100 md:w-52" />
          </div>
        </div>

        <div className="rounded-xl border border-gray-100 bg-white p-6 shadow-sm">
          <div className="mb-4 h-6 w-48 animate-pulse rounded bg-gray-100" />
          <div className="space-y-3">
            {Array.from({ length: 6 }).map((_, index) => (
              <div
                key={`customers-skeleton-row-${index}`}
                className="h-14 animate-pulse rounded bg-gray-100"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminCustomersSkeleton

